import { createAPI } from '../../composable/useAPI';
const api = createAPI();

const BASE = '/api/kpi-admin';

export const KpiAdminService = {
  async status(pushDate) {
    const params = pushDate ? { push_date: pushDate } : {};
    const res = await api.get(`${BASE}/status`, { params });
    return res.data;
  },

  async companyStatus(companySeq, limit = 30) {
    const res = await api.get(`${BASE}/status/${companySeq}`, { params: { limit } });
    return res.data;
  },

  async report(year, month) {
    const res = await api.get(`${BASE}/report/${year}/${month}`);
    return res.data;
  },

  async coverage(year, month) {
    const res = await api.get(`${BASE}/coverage/${year}/${month}`);
    return res.data;
  },

  async dueStatus(at) {
    const params = at ? { at } : {};
    const res = await api.get(`${BASE}/due-status`, { params });
    return res.data;
  },

  async pipeline(year, month, day) {
    const params = day ? { day } : {};
    const res = await api.get(`${BASE}/pipeline/${year}/${month}`, { params });
    return res.data;
  },

  async calendar(year, month) {
    const res = await api.get(`${BASE}/pipeline/${year}/${month}/calendar`);
    return res.data;
  },

  async alerts(limit = 50) {
    const res = await api.get(`${BASE}/alerts`, { params: { limit } });
    return res.data;
  },

  async verify(pushDate) {
    const res = await api.post(`${BASE}/verify/${pushDate}`);
    return res.data;
  },

  async verifySingle(pushDate, companySeq) {
    const res = await api.post(`${BASE}/verify/${pushDate}/${companySeq}`);
    return res.data;
  },

  async retryAll(pushDate) {
    const params = pushDate ? { push_date: pushDate } : {};
    const res = await api.post(`${BASE}/retry`, null, { params });
    return res.data;
  },

  async retryCompany(companySeq) {
    const res = await api.post(`${BASE}/retry/${companySeq}`);
    return res.data;
  },

  async pushBatch(pushDate, levels = null) {
    const params = {};
    if (pushDate) params.push_date = pushDate;
    if (levels) params.levels = levels;
    const res = await api.post(`${BASE}/push/batch`, null, { params });
    return res.data;
  },

  async pushSingle(companySeq, pushDate, levels = null) {
    const params = {};
    if (pushDate) params.push_date = pushDate;
    if (levels) params.levels = levels;
    const res = await api.post(`${BASE}/push/test/${companySeq}`, null, { params });
    return res.data;
  },

  async pauseCompany(companySeq, reason, pausedBy = 'admin') {
    const res = await api.post(`${BASE}/pause/${companySeq}`, { reason, paused_by: pausedBy });
    return res.data;
  },

  async resumeCompany(companySeq) {
    const res = await api.post(`${BASE}/resume/${companySeq}`);
    return res.data;
  },

  async pausedList() {
    const res = await api.get(`${BASE}/paused`);
    return res.data;
  },

  async updateStart(startDate, endDate) {
    const params = {};
    if (startDate) params.start_date = startDate;
    if (endDate) params.end_date = endDate;
    const res = await api.post(`${BASE}/update/start`, null, { params });
    return res.data;
  },

  async updateProgress() {
    const res = await api.get(`${BASE}/update/progress`);
    return res.data;
  },

  async updateStop() {
    const res = await api.post(`${BASE}/update/stop`);
    return res.data;
  },
};
